import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";

interface BackButtonProps {
  onBack?: () => void;
  showStroke?: boolean;
}

export default function BackButton({
  onBack,
  showStroke = true,
}: BackButtonProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        py: "12px",
        pl: 5,
        borderTop: showStroke ? "1px solid #E4E7EC" : "none",
        borderBottom: showStroke ? "1px solid #E4E7EC" : "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Button
        startIcon={<ChevronLeft />}
        onClick={handleBack}
        sx={{
          color: "#667185",
          textTransform: "none",
          minWidth: "auto",
          padding: "6px 12px",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#F2F4F7",
          },
        }}
      >
        Back
      </Button>
    </Box>
  );
}
